import { Button, Modal, Input, Form, message, DatePicker, Row, Typography } from 'antd';
import moment from 'moment';
import React from 'react';

import { scheduleMatchDay, updateMatchDay } from 'api/events';
import CoordsField from 'components/Form/CoordsField';
import { general, matchStatuses } from 'configs';
import { cancelMatchModal } from '../ConfirmCancelMatchModal/ConfirmCancelMatchModal';
import { messages } from 'constants/index';

const { Text } = Typography;
const { CANCELLED, FINISHED } = matchStatuses;

export const EncounterModal = ({
  onLoadRounds,
  isVisible,
  setIsModalVisible,
  match,
  matchDayId,
  isEditEncounter,
}) => {
  const { id: matchId, date_time, lat, lng, place_name, status } = match || {};

  const handleOnSubmit = async ({ date_time, coordinates: { lat, lng }, place_name }) => {
    const data = {
      date_time: date_time,
      place_name,
      lng: lng,
      lat: lat,
    };
    message.loading('Actualizando encuentro', 1);
    try {
      if (isEditEncounter) {
        await updateMatchDay(Number(matchDayId), Number(matchId), data);
        message.success(messages.onMatchUpdated);
      } else {
        await scheduleMatchDay(Number(matchDayId), Number(matchId), data);
        message.success(messages.onMatchScheduled);
      }
      await onLoadRounds();
    } catch (error) {
      message.error(messages.onError);
    }
  };

  //   scheduleMatchDay;
  //   updateMatchDay;
  return (
    <Modal
      visible={isVisible}
      title={isEditEncounter ? 'Editar encuentro' : 'Programar encuentro'}
      onCancel={() => setIsModalVisible(false)}
      footer={[
        <Button onClick={() => setIsModalVisible(false)} key="back">
          Cancelar
        </Button>,
        <Button form={'scheduleForm'} htmlType="submit" key="submit" type="primary">
          Aceptar
        </Button>,
      ]}
    >
      <Form layout="vertical" id={'scheduleForm'} onFinish={values => handleOnSubmit(values)}>
        <Form.Item
          initialValue={date_time && moment(date_time)}
          label="Fecha de Inicio"
          name="date_time"
          rules={[
            {
              required: true,
              message: 'Ingrese la fecha de inicio!',
            },
          ]}
        >
          <DatePicker
            showTime={{ format: general.displayTime }}
            format={general.displayDateTime}
            className="w-100"
            showNow={false}
          />
        </Form.Item>
        <Form.Item
          initialValue={status !== CANCELLED && place_name ? place_name : ''}
          label="Nombre del Lugar"
          name="place_name"
          rules={[
            {
              required: true,
              message: 'Ingrese el nombre del lugar!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          initialValue={{ lat: lat && Number(lat), lng: lng && Number(lng) }}
          label="Mapa"
          name="coordinates"
          rules={[
            {
              required: true,
              message: 'Ingrese la locación!',
            },
          ]}
        >
          <CoordsField />
        </Form.Item>
      </Form>
      {isEditEncounter && status !== FINISHED && (
        <Row justify="center">
          <Text
            className="cursor-pointer"
            onClick={() =>
              cancelMatchModal(Number(matchDayId), Number(matchId), onLoadRounds, setIsModalVisible)
            }
            type="danger"
          >
            Cancelar encuentro
          </Text>
        </Row>
      )}
    </Modal>
  );
};
